ceregoLayoutApp.controller('headCtrl', ['$scope', '$routeParams', '$filter', ($scope, $routeParams, $filter) ->
  _.assignIn $scope,
    tagline: "The standard for personalized learning"
    meta: {}

  $scope.$on '$routeChangeSuccess', ($event, current, previous) ->
    $scope.meta.title = ($filter('translate')(current.locals.$titleTag) || current.locals.$titleTag || $scope.tagline) + " | Cerego"
])
